module.exports = __webpack_public_path__ + "static/img/device.807bab66.png";